import request from '@/utils/httpClient'
import { PurchaseCreateParams, PurchaseUpdateParams, PurchaseInAdvanceParams, PurchasePageParams } from '@/types/domain/purchase'

// 创建采购单
export function createPurchase(data: PurchaseCreateParams) {
  return request({
    url: 'purchase',
    method: 'POST',
    data
  })
}

// 更新采购单
export function updatePurchase(id: number, data: PurchaseUpdateParams) {
  return request({
    url: `purchase/${id}`,
    method: 'put',
    data
  })
}

// 分页查询采购单 (类型化领域查询)
export function getPurchasePage(params?: PurchasePageParams) {
  return request({
    url: 'purchase/page',
    method: 'get',
    params
  })
}

// 创建预采购
export function createPurchaseInAdvance(data: PurchaseInAdvanceParams) {
  return request({
    url: 'purchaseInAdvance',
    method: 'POST',
    data
  })
}

// 更新预采购
export function updatePurchaseInAdvance(data: PurchaseInAdvanceParams) {
  return request({
    url: 'purchaseInAdvance',
    method: 'POST',
    data
  })
}

// 财务付款
export function paymentConfirm(data?: object) {
  return request({
    url: 'purchase/details/actions/payment',
    method: 'put',
    data
  })
}

// 登记发票
export function dengjiTicket(id: number, data?: object) {
  return request({
    url: `purchase/${id}/actions/ticket`,
    method: 'put',
    data
  })
}

// 批量登记发票
export function batchDengjiTicket(data?: object) {
  return request({
    url: 'purchase/details/actions/ticket',
    method: 'put',
    data
  })
}

// 作废发票
export function cancelTicket(id: number) {
  return request({
    url: `purchase/${id}/actions/ticket/cancel`,
    method: 'put'
  })
}
